import { Box, Typography } from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../../App';
import OrderHeader from '../OrderHeader/OrderHeader';


const Review = () => {
    const [value, setValue] = useState(0);
    const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    const [info, setInfo] = useState({})
    const handleBlur = (e) => {
        setInfo({...info, [e.target.name]: e.target.value})
    }
    const [success, setSuccess] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        const user = loggedInUser.photoURL
        const review = {...info, user, value}
        fetch('https://assignment-11-samiun.herokuapp.com/addReview', {
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(review)
        })
        .then(res => res.json())
        .then(data => {
            if(data){
                setSuccess('review added successfully')
            }
        })
    }

    return (
        <div className="row">
            <div className="col-md-2">
                <OrderHeader />
            </div>
            <div className="col-md-10 mt-4">
                <h3 className="mb-2">Order</h3>
                <div className="mt-3 ps-5 pt-5" style={{background: '#F4F7FC', height: '100vh'}}>
                <form onSubmit={handleSubmit} >
                    <div className="d-flex">
                    <input type="text" class="form-control mb-4" placeholder="Your name" style={{width: '500px', border: 'none', padding: '10px 15px', marginRight: '50px'}}  required name="name" onBlur={handleBlur}/>
                    <Box component="fieldset" mb={3} borderColor="transparent">
                        <Typography component="legend">Rating</Typography>
                        <Rating
                        name="simple-controlled"
                        value={value}
                        name="ratings"
                        onChange={(event, newValue) => {
                            setValue(newValue);
                        }}
                        />
                    </Box>
                    </div>
                    <input type="text" class="form-control mb-4" placeholder="Designation, Company's name" style={{width: '500px', border: 'none', padding: '10px 15px'}} required name="designation" onBlur={handleBlur} />
                    <textarea class="form-control" placeholder="description" rows="4" style={{width: '500px', border: 'none', padding: '10px 15px'}} required name="review" onBlur={handleBlur}></textarea>
                    <button className="btn-style mt-4" style={{width: '150px'}} type="submit">Submit</button>
                    {success && <div className="alert alert-success mt-3">{success}</div>}
                </form>
                </div>
            </div>
        </div>
    );
};

export default Review;